import _ from "lodash";
import React from "react";

import { RadioButton } from "@toddle-edu/ds-web";
import { StarsTwoFilled } from "@toddle-edu/ds-icons";
import NewTag from "ClassRoom/components/AddAssignment/LessonPlanningAssistant/components/NewTag";

import classNames from "classnames";

import classes from "./Prompt.scss";

const Prompt = props => {
  const { t, prompt, selectedPrompt, onSelectedPromptChange } = props;
  const { label, isNewTagVisible = false } = prompt;

  const isSelected = selectedPrompt?.id === prompt.id;

  const onPromptClick = selectedPromptIds => {
    if (
      _.includes(selectedPromptIds, prompt.id) &&
      !_.includes(selectedPromptIds, selectedPrompt.id)
    ) {
      onSelectedPromptChange(prompt);
    } else {
      onSelectedPromptChange({});
    }
  };

  // classes

  const promptContainerClass = classNames({
    [classes.promptContainer]: true,
    [classes.selectedPromptContainer]: isSelected,
  });

  const displayTextClass = classNames("text-body-2", classes.displayText, {
    [classes.selectedDisplayText]: isSelected,
  });

  const radioButtonClass = classNames({
    [classes.radioButton]: true,
    [classes.selectedRadioButton]: isSelected,
  });

  return (
    <div
      key={prompt.id}
      className={promptContainerClass}
      onClick={() => onPromptClick([prompt.id])}
    >
      <StarsTwoFilled variant={isSelected ? "link" : "subtle"} />
      <div className={classes.promptRightContainer}>
        <div className={displayTextClass}>
          {label}
          <NewTag t={t} isNewTagVisible={isNewTagVisible} />
        </div>
        <div className={radioButtonClass}>
          <RadioButton
            checked={isSelected}
            shouldStopPropagation={true}
            onClick={() => onPromptClick([prompt.id])}
            testId={
              "worksheet-worksheetAssistant-PromptSuggestionModal-selectPrompt"
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Prompt;
